import FPVue from "../FP.vue";
import serviceErrorHandling from "../mixins/serviceErrorHandling";
import { DeviceWithRegistrationInformation, systemConfigurationService } from "../services";

export default FPVue.extend({
  name: "al-reset-device-registration",
  mixins: [serviceErrorHandling],
  data: function() {
    return {
      serialNumber: "",
      // serialNumber: "AC01DC2A2CFA4B3E1222",
      // serialNumber: "AB01E7587CCDDD1B4242",
      apiKey: "" as string | null,
      // apiKey: "123456" as string | null,
      device: null as DeviceWithRegistrationInformation | null | undefined,
      rules: {
        required: (value: any) => !!value || "Required."
      }
    };
  },
  computed: {},
  methods: {
    onSubmit(e: Event) {
      e.preventDefault();
    },
    clear() {
      this.device = null;
      this.serialNumber = "";
    },
    async loadDeviceDetails() {
      this.inlineMessage.message = null;

      if (!(this.$refs.form as HTMLFormElement).validate()) {
        return;
      }
      if (!this.apiKey?.length || !this.serialNumber?.length) {
        this.inlineMessage.message = "Fill in all data.";
        this.inlineMessage.type = "error";
        return;
      }

      this.processing = true;
      try {
        this.device = await systemConfigurationService.loadDeviceDetails(
          this.serialNumber,
          this.apiKey
        );
      } catch (error) {
        console.log(`error: ${error}`);
        this.handleError(error);
      } finally {
        this.processing = false;
      }
    },
    async resetDeviceRegistrations() {
      this.inlineMessage.message = null;
      if (!this.device) {
        this.inlineMessage.message = "Must load device details.";
        this.inlineMessage.type = "error";
        return;
      }
      if (!this.apiKey?.length) {
        this.inlineMessage.message = "Enter an API key.";
        this.inlineMessage.type = "error";
        return;
      }
      this.processing = true;
      try {
        if (this.device.deviceType == "hub") {
          this.device = await systemConfigurationService.resetHub(this.device.id, this.apiKey);
        } else {
          this.device = await systemConfigurationService.resetController(
            this.device.id,
            this.apiKey
          );
        }
      } catch (error) {
        console.log(`error: ${error}`);
        this.handleError(error);
      } finally {
        this.processing = false;
      }
    }
  },
  created: async function() {}
});

